module.exports = __webpack_public_path__ + "assets/img/left.d8cf3454.svg";